import React from "react";

export default function Empty(): JSX.Element {
	return <></>;
}
